import request from "@/utils/request";
//查询服务器时间
export function currentTimeStamp () {
  return request({
    url: "/fee-service/currentTimeStamp",
    method: "get"
  });
}